// extracted by mini-css-extract-plugin
module.exports = {"articleContent":"articleContent_articleContent___k9r_"};